(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/freja/other-device.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/freja/other-device.js');

'use strict';

const {
  Events: AuthenticateEvents
} = svs.accountservices.authenticate.definitions;
svs.player_login.views.freja.OtherDevice = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.freja_other_device(data);
  },
  ui: {
    qrContainer: '.js-qr-container',
    qrHelp: '.js-qr-help',
    retryButton: '.js-retry',
    qrSpinner: '.js-qr-spinner'
  },
  behaviors: {
    About: {
      behaviorClass: svs.player_login.behaviors.About
    },
    Login: {
      behaviorClass: svs.player_login.behaviors.Login
    },
    Navigation: {
      behaviorClass: svs.player_login.behaviors.Navigation
    }
  },
  events: {
    'click @ui.qrHelp': 'onQrHelpClick',
    'click @ui.retryButton': 'onRetryClick'
  },
  initialize() {
    this.authenticateEvents = {
      [AuthenticateEvents.READY_TO_POLL]: this.onReadyToPoll,
      [AuthenticateEvents.RETRY]: this.generateQR,
      [AuthenticateEvents.RETRIES_FINISHED]: this.onRetriesFinished
    };
    svs.accountservices.authenticate.login.on(this.authenticateEvents, this);
  },
  onAttach() {
    this.loader = new svs.ui.Loader(this.getUI('qrSpinner'));
    this.loader.show(300, 'inverted');
    svs.accountservices.authenticate.login.start({
      method: svs.accountservices.authenticate.definitions.LoginMethods.FREJA,
      qr: true,
      codeChallenge: this.model.get('codeChallenge'),
      codeChallengeMethod: this.model.get('codeChallengeMethod'),
      isCustomerRegistration: this.model.get('isCustomerRegistration'),
      isPoker: this.model.get('isPoker')
    });
  },
  onBeforeError() {
    this.loader.hide();
  },
  onError() {
    this.getUI('qrContainer').empty().html(svs.player_login.templates.get_new_qr());
  },
  onRetryClick() {
    this.getUI('qrContainer').empty().html(svs.player_login.templates.qr_spinner());
    this.bindUIElements();
    this.loader = new svs.ui.Loader(this.getUI('qrSpinner'));
    this.loader.show(300, 'inverted');
    svs.accountservices.authenticate.login.start({
      method: svs.accountservices.authenticate.definitions.LoginMethods.FREJA,
      qr: true,
      codeChallenge: this.model.get('codeChallenge'),
      codeChallengeMethod: this.model.get('codeChallengeMethod'),
      isCustomerRegistration: this.model.get('isCustomerRegistration'),
      isPoker: this.model.get('isPoker')
    });
  },
  onReadyToPoll(data) {
    this.loader.hide();
    this.model.set('loginToken', data.loginToken);
    this.generateQR(data);
    svs.accountservices.authenticate.login.poll();
  },
  onRetriesFinished() {
    this.getUI('qrContainer').empty().html(svs.player_login.templates.get_new_qr());
  },
  generateQR() {
    this.getUI('qrContainer').empty().qrcode({
      size: 120,
      color: '#3a3',
      text: svs.accountservices.authenticate.login.getAppUrl()
    });
  },
  onQrHelpClick(e) {
    svs.ui.dialog.api.add(new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
      attachTo: $(e.currentTarget),
      zIndex: 1050,
      width: 300,
      title: ' ',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        align: svs.ui.dialog.message.align.LEFT,
        text: "1. \xD6ppna din Freja eID-app i din mobila enhet.<br>\n                   2. V\xE4lj QR-kod/QR-Code.<br>\n                   3. L\xE4s av QR-koden med din mobila enhet.<br>\n                   4. Identifiera dig med kod eller fingeravtryck i Freja eID-appen."
      }]
    }));
  },
  onDestroy() {
    svs.accountservices.authenticate.login.off(this.authenticateEvents);
    svs.accountservices.authenticate.login.cancel();
  }
});

 })(window);